<app-main-nav-bar></app-main-nav-bar>
<!--1-->
<div class="page-wrapper bg-red p-t-180 p-b-100">
  <div class="wrapper wrapper--w960">
    <div class="card card-2">
      <div class="card-body">
        <div class="location elem" style="display: block;">
          <div class="row">
            <div class="col col-12">
              <div class="head">
                <h2>اطلاعات اولیه</h2>
                <p>اطلاعات خود را وارد نمایید</p>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col col-12">
              <form [formGroup]="basicInformationForm">
                <app-input-field [Group]="basicInformationForm"
                                 [fieldName]="'insuranceNumber'"
                                 [fieldLabel]="'شماره بیمه نامه'"
                                 [dataType]="['varchar']"></app-input-field>
                <br>
                <br>
                <app-custom-button
                  [disabled]="!basicInformationForm.valid"
                  [BackButton]="true"
                  [backUrl]="'/introduction-letter'"
                  (OnClick)="goNext()"
                  [LabelText]="'ادامه'"
                  [Show]="true">
                </app-custom-button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
